import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../../../redux/connect';
import {
  getActiveUsers,
  getCurrentViewType,
} from '../../../../../../redux/selectors';
import classNames from 'classnames';
import DistributionListInlineEdit from './components/DistributionListInlineEdit';
import { issueAttributesType } from '../../../../../../constants/proptype-validation';
import { viewTypes } from '../../../../../../constants/view-types';
import IssueFieldInlineEdit from '../../../../../IssueFieldInlineEdit';
import T from "i18n-react";
import { toLocalLongDate } from "../../../../../../utils/date-helpers";
import EditFormField from "./components/EditFormField";

class IssuePreviewDetailsTabDistributionListSection extends PureComponent {

  render() {
    const { issue, users, viewType, container } = this.props;
    const { createdByDisplayNameWithCompanyName, createdAt } = issue;
    const formClassNames = classNames('IssuePreviewDetailsTabDistributionListSection', {
      'IssuePreviewDetailsTabDistributionListSection__narrow': viewType === viewTypes.DOCUMENT,
      'IssuePreviewDetailsTabDistributionListSection__wide': viewType === viewTypes.PROJECT,
    });
    return (
      <form className={formClassNames}>
        {/* Distribution List */}
        <DistributionListInlineEdit
          issue={issue}
          users={users}
          container={container}
          styleType={IssueFieldInlineEdit.StyleTypes.DEFAULT}
          horizontalAlign
        />
        <EditFormField label={T.translate('creation.createdBy')} horizontalAlign={true}>
          <div className="IssuePreviewDetailsTabDistributionListSection__creation-container">
            <span className="IssuePreviewDetailsTabDistributionListSection__creation-details"
              data-testid="IssuePreviewDetailsTabDistributionListSection__creation-details"
            >{createdByDisplayNameWithCompanyName || T.translate('userUndefined')}</span>
            <span
              className="IssuePreviewDetailsTabDistributionListSection__creation-date"
            >{` ${T.translate('creation.on')} ${toLocalLongDate(createdAt)}`}</span>
          </div>
        </EditFormField>
      </form>
    );
  }
}

IssuePreviewDetailsTabDistributionListSection.displayName = 'IssuePreviewDetailsTabDistributionListSection';

IssuePreviewDetailsTabDistributionListSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired,
  container: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  users: getActiveUsers(state),
  viewType: getCurrentViewType(state),
});

export default connect(mapStateToProps)(IssuePreviewDetailsTabDistributionListSection);
